export const sans = "'Inter', sans-serif";

export const typo = {
  patrimoineNet: { size: 34, weight: 800, tnum: true },
  scoreGauge: { sizePercent: 32, weight: 800 },
  evolutionValue: { size: 22, weight: 800, tnum: true },
  kpiGauge: { size: 18, weight: 700 },
  donutCenter: { sizePercent: 16, weight: 700 },
  sectionTitle: { size: 13, weight: 700 },
  bodyStrong: { size: 12.5, weight: 600 },
  amountRow: { size: 12.5, weight: 600, tnum: true },
  badgeText: { size: 10, weight: 600 },
  microLabel: { size: 9, weight: 600, uppercase: true },
} as const;
